import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../html/element'
import { Loading } from '../../../loading'
import {
  getTotalCompanyBySetting,
  selectLoadingTotalCompanies,
} from '../../store/sliceTotalCompanies'
import { ButtonBack } from '../components/buttonBack/ButtonBack'

export const Header = ({ buttonBackProps }) => {
  const total = useSelector(getTotalCompanyBySetting)
  const loading = useSelector(selectLoadingTotalCompanies)

  return (
    <div style={{ padding: '0 6px' }}>
      <ButtonBack {...buttonBackProps} />
      <div className="dFlex gap1 alignItemsCenter" style={{ paddingBottom: 6 }}>
        <Element className="fw500" style={{ fontSize: 20, color: '#191D25' }}>
          <Translate value="library.filterSetting.FILTER_SETTING" />
        </Element>
        <Element
          className="positionRelative"
          style={{
            fontSize: 14,
            backgroundColor: '#2C73E8',
            color: '#FFFFFF',
            borderRadius: '2px',
            padding: '2px 11px',
            opacity: loading ? 0.6 : 1,
          }}
        >
          {loading && <Loading />}
          <Translate
            value={`library.filterCompanies.${
              !total || total < 2 ? 'COMPANY' : 'COMPANIES'
            }`}
            count={total}
          />
        </Element>
      </div>
    </div>
  )
}
